/** Role-aware empty-state / suggestion prompts (no LLM). */

import { RoleList } from 'app/core/enums';

const FM = [
    'My film views last 7 days',
    'Show my films',
    'Show my drafts',
    'Wallet balance',
    'How do I upload a film?',
    'Where is my referral code?',
    'Help and support',
];

const ADMIN_CORE = [
    'Film views last 7 days',
    'Show revenue last 7 days',
    'Which movies are ready for approve?',
    'Films in review',
    'List draft films',
    'Who is mobile 9876543210?',
    'How do I upload a film?',
    'What can I access?',
    'Help and support',
];

const FINANCE = [
    'Show revenue last 7 days',
    'Where is invoice report?',
    'Open purchase report',
    'Wallet report',
    'What can I access?',
    'Help and support',
];

const CURATOR = [
    'Which movies are ready for approve?',
    'Films in review',
    'List draft films',
    'How to update home page film listing?',
    'What is the status of "Movie Name"?',
    'What can I access?',
    'Help and support',
];

const AGENT = [
    'Who is mobile 9876543210?',
    'List filmmakers',
    'List viewers',
    'How do I upload a film?',
    'Help and support',
];

const DEFAULT_ADMIN = ADMIN_CORE;

export function roleSuggestionPrompts(role: string | null | undefined): string[] {
    const r = String(role || '').toUpperCase();
    if (r === RoleList.FilmMaker || r === 'FILM_MAKER') return [...FM];
    if (r === RoleList.Finance || r === 'FINANCE') return [...FINANCE];
    if (
        r === RoleList.ContentCurator ||
        r === RoleList.Curator ||
        r === 'CONTENT_CURATOR' ||
        r === 'CURATOR'
    ) {
        return [...CURATOR];
    }
    if (r === RoleList.Agent || r === 'AGENT') return [...AGENT];
    if (
        r === RoleList.SuperAdmin ||
        r === RoleList.Admin ||
        r === RoleList.QA ||
        r === RoleList.IT ||
        r === RoleList.Monitor ||
        r === RoleList.MarketingAgency
    ) {
        return [...ADMIN_CORE];
    }
    return [...DEFAULT_ADMIN];
}

export function roleSubtitle(role: string | null | undefined): string {
    const r = String(role || '').toUpperCase();
    if (r === RoleList.FilmMaker || r === 'FILM_MAKER') {
        return 'Your films · wallet · how-to';
    }
    if (r === RoleList.Finance || r === 'FINANCE') {
        return 'Revenue · invoices · reports';
    }
    if (
        r === RoleList.ContentCurator ||
        r === RoleList.Curator ||
        r === 'CONTENT_CURATOR'
    ) {
        return 'Review queue · home page · catalog';
    }
    if (r === RoleList.Agent || r === 'AGENT') {
        return 'Users · partners · Studio help';
    }
    return 'Studio AI · live answers';
}
